import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalMessageHandlerService } from '@core/frontend-shared';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { filter } from 'rxjs';
import { CRUD_ITEM_VIEW_SERVICE_TOKEN } from './token';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@core/frontend-shared";
/**
 * base class handling loading and preparing of a CrudItem.
 * subscribe to crudManager.modeAndItem$ to get the loaded Item.
 */
export let CrudItemViewComponent = /*#__PURE__*/(() => {
  class CrudItemViewComponent {
    constructor(cd, crudItemViewService, route, router, messages) {
      this.cd = cd;
      this.crudItemViewService = crudItemViewService;
      this.route = route;
      this.router = router;
      this.messages = messages;
      this.destroyRef = inject(DestroyRef);
      if (!this.crudItemViewService) throw new Error('Missing dependency: CrudItemViewService was not found.');
      // allow child constructor to execute before bindObservables
      setTimeout(() => this.bindObservables(), 1);
    }
    bindObservables() {
      this.crudItemViewService.itemEditorDetails$.pipe(takeWhileAlive(this.destroyRef), filter(config => !!config)).subscribe(config => {
        // console.log('itemEditorDetails$ emitted',config)
        this.handleConfigurationUpdate(config);
        this.cd.markForCheck();
      });
      // NOTE: not needed anymore. FormService will re-patch form with persisted value in save subscriber.
      // Additionally it will emit FsOnAfterSaveEvent, which triggers CrudItemViewService.onAfterSave.
      // In case an edge case is discovered which is not working well anymore, it must be documented.
      // + Implementation must take care not to introduce duplicate reloads.
      // this.crudItemViewService.crudService.listenToCrudStateEvents$().pipe(
      // 	takeWhileAlive(this.destroyRef)
      // ).subscribe(event=>{
      // 	if(event.eventType===CrudRequestEventType.RequestCompleted) {
      // 		if(event.crudAction===CrudRequestType.Update) {
      // 			console.log('trigger reload from CrudItemViewComponent due to crudStateEvents emission')
      // 			// this.refresh()
      // 		}
      // 	}
      // })
    }
    refresh() {
      this.crudItemViewService.reload(true);
    }
    closeView() {
      this.crudItemViewService.navigateTo('list');
    }
    static {
      this.ɵfac = function CrudItemViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudItemViewComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CRUD_ITEM_VIEW_SERVICE_TOKEN), i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.LocalMessageHandlerService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudItemViewComponent,
        selectors: [["ng-component"]],
        decls: 0,
        vars: 0,
        template: function CrudItemViewComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return CrudItemViewComponent;
})();